module.exports = __webpack_public_path__ + "static/media/validate-identity.2fadd6a4.svg";